<div class="catalog__hitsPerPage">
  <ng-container i18n="@@CATALOG.FILTERS.HITS_PER_PAGE_LABEL">Results per page</ng-container>

  <button
    *ngFor="let item of items"
    class="catalog__hitsPerPage__pageLink"
    [class.catalog__hitsPerPage__pageLink--active]="item.isRefined"
    (click)="state.refine(item.value)"
  >
    {{ item.value }}
  </button>
</div>
